import { render, staticRenderFns } from "./LoginError.vue?vue&type=template&id=5a2a7946&scoped=true"
import script from "./LoginError.vue?vue&type=script&lang=ts"
export * from "./LoginError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2a7946",
  null
  
)

export default component.exports